<template>
	<router-view v-slot="{ Component }">
		<transition name="slide-up" mode="out-in">
			<div v-if="$route.name === 'siswa'" class="card">
				<div class="card-header">
					<div class="d-flex flex-wrap align-items-center gap-2">
						<span class="fs-6">Progres Kelengkapan Data Rinci Siswa</span>
						<el-select v-model="semester" value-key="semester_id" placement="bottom-end" placeholder="Semester" class="ms-auto" style="width: 200px">
							<el-option v-for="s in listSemester" :key="s" :label="s.nama" :value="s" />
						</el-select>
					</div>
				</div>
				<div class="card-body">
					<el-row :gutter="10" justify="end" align="middle" class="mb-2" wrap>
						<el-col :xs="20" :sm="12" :md="8" :xl="6" class="text-end">
							<el-button @click="clearSort" type="info" plain v-if="orders.length > 0">Atur ulang sortir</el-button>
							<el-button @click="clearFilter" type="info" plain v-if="filters.length > 0">Atur ulang filter</el-button>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :xl="6">
							<el-input v-model="searchKey" placeholder="Cari . . ." prefix-icon="Search" clearable />
						</el-col>
					</el-row>
					<el-table
						ref="tableProgresSemuaSiswa"
						:data="semuaSiswa"
						row-key="siswa_id"
						table-layout="auto"
						border
						stripe
						:header-cell-class-name="handleHeaderClass"
						@selection-change="changeSelection"
						@filter-change="handleFilterChange"
						@sort-change="handleSortChange"
						v-loading="loading">
						<template #empty>
							<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
						</template>
						<el-table-column type="index" label="No." align="center" width="10" :index="indexMethod" />
						<el-table-column prop="nis" label="NIS" align="center" />
						<el-table-column prop="nama_siswa" label="Nama" min-width="200px">
							<template #default="{ row }">
								<div class="hstack gap-1 justify-content-between">
									<span>{{ row.nama_siswa }}</span>
									<el-tooltip content="Lihat detail kelengkapan">
										<router-link :to="{ name: 'siswa-progres', params: { siswaId: row.siswa_id } }">
											<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
										</router-link>
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="nama_rombel" label="Rombel" align="center" />
						<el-table-column label="Persentase Kelengkapan Data" align="center">
							<el-table-column
								prop="progres_detail_siswa"
								column-key="progres_detail_siswa"
								label="Detail Siswa"
								align="center"
								sortable="custom"
								label-class-name="small"
								:filters="filterOptions.detailSiswa"
								:filter-multiple="false">
								<template #header>
									Detail Siswa
									<em v-if="activeFilters.has('progres_detail_siswa')">({{ activeFilters.get("progres_detail_siswa") }})</em>
								</template>
								<template #filter-icon>
									<i class="bi bi-funnel-fill" style="color: var(--el-color-primary)" v-if="filters.some((f) => f.column === 'progres_detail_siswa')"></i>
									<i class="bi bi-funnel" v-else></i>
								</template>
								<template #default="{ row }">
									<router-link
										:to="{ name: 'siswa-detail', params: { siswaId: row.siswa_id } }"
										:class="row.progres_detail_siswa_class"
										:key="row.progres_detail_siswa"
										class="text-decoration-none">
										{{ row.progres_detail_siswa }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column
								prop="progres_data_ayah"
								column-key="progres_data_ayah"
								label="Data Ayah"
								align="center"
								sortable="custom"
								label-class-name="small"
								:filters="filterOptions.dataAyah"
								:filter-multiple="false">
								<template #header>
									Data Ayah
									<em v-if="activeFilters.has('progres_data_ayah')">({{ activeFilters.get("progres_data_ayah") }})</em>
								</template>
								<template #filter-icon>
									<i class="bi bi-funnel-fill" style="color: var(--el-color-primary)" v-if="filters.some((f) => f.column === 'progres_data_ayah')"></i>
									<i class="bi bi-funnel" v-else></i>
								</template>
								<template #default="{ row }">
									<router-link
										:to="{ name: 'siswa-data-ayah', params: { siswaId: row.siswa_id } }"
										:class="row.progres_data_ayah_class"
										:key="row.progres_data_ayah"
										class="text-decoration-none">
										{{ row.progres_data_ayah }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column
								prop="progres_data_ibu"
								column-key="progres_data_ibu"
								label="Data Ibu"
								align="center"
								sortable="custom"
								label-class-name="small"
								:filters="filterOptions.dataIbu"
								:filter-multiple="false">
								<template #header>
									Data Ibu
									<em v-if="activeFilters.has('progres_data_ibu')">({{ activeFilters.get("progres_data_ibu") }})</em>
								</template>
								<template #filter-icon>
									<i class="bi bi-funnel-fill" style="color: var(--el-color-primary)" v-if="filters.some((f) => f.column === 'progres_data_ibu')"></i>
									<i class="bi bi-funnel" v-else></i>
								</template>
								<template #default="{ row }">
									<router-link
										:to="{ name: 'siswa-data-ibu', params: { siswaId: row.siswa_id } }"
										:class="row.progres_data_ibu_class"
										:key="row.progres_data_ibu"
										class="text-decoration-none">
										{{ row.progres_data_ibu }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column
								prop="progres_data_wali"
								column-key="progres_data_wali"
								label="Data Wali"
								align="center"
								sortable="custom"
								label-class-name="small"
								:filters="filterOptions.dataWali"
								:filter-multiple="false">
								<template #header>
									Data Wali
									<em v-if="activeFilters.has('progres_data_wali')">({{ activeFilters.get("progres_data_wali") }})</em>
								</template>
								<template #filter-icon>
									<i class="bi bi-funnel-fill" style="color: var(--el-color-primary)" v-if="filters.some((f) => f.column === 'progres_data_wali')"></i>
									<i class="bi bi-funnel" v-else></i>
								</template>
								<template #default="{ row }">
									<router-link
										:to="{ name: 'siswa-data-wali', params: { siswaId: row.siswa_id } }"
										:class="row.progres_data_wali_class"
										:key="row.progres_data_wali"
										class="text-decoration-none">
										{{ row.progres_data_wali }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column
								prop="progres_total"
								column-key="progres_total"
								label="Total"
								align="center"
								sortable="custom"
								label-class-name="small"
								class-name="fw-bold"
								:filters="filterOptions.total"
								:filter-multiple="false">
								<template #header>
									Total
									<em v-if="activeFilters.has('progres_total')">({{ activeFilters.get("progres_total") }})</em>
								</template>
								<template #filter-icon>
									<i class="bi bi-funnel-fill" style="color: var(--el-color-primary)" v-if="filters.some((f) => f.column === 'progres_total')"></i>
									<i class="bi bi-funnel" v-else></i>
								</template>
								<template #default="{ row }">
									<span :class="row.progres_total_class" :key="row.progres_total">{{ row.progres_total }}%</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="last_update"
								column-key="kunci_data"
								label="Status"
								align="center"
								label-class-name="small"
								:filters="filterOptions.kunciData"
								:filter-multiple="false">
								<template #header>
									Status
									<el-icon v-if="activeFilters.has('kunci_data') && activeFilters.get('kunci_data') === true"><Lock /></el-icon>
									<el-icon v-else-if="activeFilters.has('kunci_data') && activeFilters.get('kunci_data') === false"><Unlock /></el-icon>
								</template>
								<template #filter-icon>
									<i class="bi bi-funnel-fill" style="color: var(--el-color-primary)" v-if="filters.some((f) => f.column === 'kunci_data')"></i>
									<i class="bi bi-funnel" v-else></i>
								</template>
								<template #default="{ row }">
									<div class="hstack gap-1 justify-content-center">
										<el-tooltip>
											<template #content>
												Terakhir diperbarui:<br />
												{{ row.last_update_styled }}
											</template>
											<el-icon><i class="bi bi-info-circle"></i></el-icon>
										</el-tooltip>
										<div class="vr"></div>
										<el-tooltip :content="row.kunci_data ? `Akses edit terkunci` : `Akses edit terbuka`">
											<el-icon v-if="row.kunci_data" class="text-secondary"><Lock /></el-icon>
											<el-icon v-else class="text-success"><Unlock /></el-icon>
										</el-tooltip>
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column align="center" v-if="isPengelola">
							<template #header>
								Akses Edit
								<transition name="fade" mode="out-in">
									<div class="small" v-if="lockedSelected.length || unlockedSelected.length">
										Ubah akses edit data terpilih<br />
										<el-button-group size="small">
											<el-button type="info" v-if="unlockedSelected.length" :loading="locking" @click="kunciAksesEdit">Kunci</el-button>
											<el-button type="primary" v-if="lockedSelected.length" :loading="unlocking" @click="bukaAksesEdit">Buka</el-button>
										</el-button-group>
									</div>
								</transition>
							</template>
							<el-table-column prop="kunci_data" label="Tindakan" align="center" label-class-name="small">
								<template #default="{ row }">
									<el-popconfirm
										width="240px"
										:title="row.kunci_data ? `Buka akses pengeditan data ${row.nama_siswa}?` : `Tutup akses pengeditan data ${row.nama_siswa}?`"
										confirm-button-type="success"
										@confirm="gantiStatusKunciData(row, true)"
										@cancel="gantiStatusKunciData(row, false)">
										<template #reference>
											<transition name="fade" mode="out-in">
												<el-button :key="row.kunci_data" :type="row.kunci_data ? 'primary' : 'info'" size="small" :loading="row.loading" round plain>
													{{ row.kunci_data ? "Buka" : "Kunci" }}
												</el-button>
											</transition>
										</template>
									</el-popconfirm>
								</template>
							</el-table-column>
							<el-table-column type="selection" align="center" />
						</el-table-column>
					</el-table>
				</div>
				<div class="card-footer">
					<el-pagination
						class="flex-wrap justify-content-center bg-transparent"
						background
						v-model:current-page="currentPage"
						v-model:page-size="pageSize"
						:page-sizes="[5, 10, 25, 50, 100]"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalData"
						@change="getProgresSemuaSiswa" />
				</div>
			</div>
			<component :is="Component" v-else />
		</transition>
	</router-view>
</template>

<script>
export default {
	name: "SiswaView",
	data() {
		return {
			listSemester: [],
			semester: null,
			semuaSiswa: [],
			loading: false,
			locking: false,
			unlocking: false,
			lockedSelected: [],
			unlockedSelected: [],
			searchKey: null,
			debounceSearch: null,
			filters: [],
			activeFilters: new Map(),
			filterOptions: {
				detailSiswa: [
					{
						text: "100%",
						value: {
							label: "100%",
							key: [{ column: "progres_detail_siswa", operator: "=", value: 100 }],
						},
					},
					{
						text: "Lebih dari 85%",
						value: {
							label: ">85%",
							key: [{ column: "progres_detail_siswa", operator: ">", value: 85 }],
						},
					},
					{
						text: "65-85%",
						value: {
							label: "65-85%",
							key: [
								{ column: "progres_detail_siswa", operator: ">=", value: 65 },
								{ column: "progres_detail_siswa", operator: "<=", value: 85 },
							],
						},
					},
					{
						text: "35-65%",
						value: {
							label: "35-65%",
							key: [
								{ column: "progres_detail_siswa", operator: ">=", value: 35 },
								{ column: "progres_detail_siswa", operator: "<=", value: 65 },
							],
						},
					},
					{
						text: "Kurang dari 35%",
						value: {
							label: "<35%",
							key: [{ column: "progres_detail_siswa", operator: "<", value: 35 }],
						},
					},
					{
						text: "0%",
						value: {
							label: "0%",
							key: [{ column: "progres_detail_siswa", operator: "=", value: 0 }],
						},
					},
				],
				dataAyah: [
					{
						text: "100%",
						value: {
							label: "100%",
							key: [{ column: "progres_data_ayah", operator: "=", value: 100 }],
						},
					},
					{
						text: "Lebih dari 85%",
						value: {
							label: ">85%",
							key: [{ column: "progres_data_ayah", operator: ">", value: 85 }],
						},
					},
					{
						text: "65-85%",
						value: {
							label: "65-85%",
							key: [
								{ column: "progres_data_ayah", operator: ">=", value: 65 },
								{ column: "progres_data_ayah", operator: "<=", value: 85 },
							],
						},
					},
					{
						text: "35-65%",
						value: {
							label: "35-65%",
							key: [
								{ column: "progres_data_ayah", operator: ">=", value: 35 },
								{ column: "progres_data_ayah", operator: "<=", value: 65 },
							],
						},
					},
					{
						text: "Kurang dari 35%",
						value: {
							label: "<35%",
							key: [{ column: "progres_data_ayah", operator: "<", value: 35 }],
						},
					},
					{
						text: "0%",
						value: {
							label: "0%",
							key: [{ column: "progres_data_ayah", operator: "=", value: 0 }],
						},
					},
				],
				dataIbu: [
					{
						text: "100%",
						value: {
							label: "100%",
							key: [{ column: "progres_data_ibu", operator: "=", value: 100 }],
						},
					},
					{
						text: "Lebih dari 85%",
						value: {
							label: ">85%",
							key: [{ column: "progres_data_ibu", operator: ">", value: 85 }],
						},
					},
					{
						text: "65-85%",
						value: {
							label: "65-85%",
							key: [
								{ column: "progres_data_ibu", operator: ">=", value: 65 },
								{ column: "progres_data_ibu", operator: "<=", value: 85 },
							],
						},
					},
					{
						text: "35-65%",
						value: {
							label: "35-65%",
							key: [
								{ column: "progres_data_ibu", operator: ">=", value: 35 },
								{ column: "progres_data_ibu", operator: "<=", value: 65 },
							],
						},
					},
					{
						text: "Kurang dari 35%",
						value: {
							label: "<35%",
							key: [{ column: "progres_data_ibu", operator: "<", value: 35 }],
						},
					},
					{
						text: "0%",
						value: {
							label: "0%",
							key: [{ column: "progres_data_ibu", operator: "=", value: 0 }],
						},
					},
				],
				dataWali: [
					{
						text: "100%",
						value: {
							label: "100%",
							key: [{ column: "progres_data_wali", operator: "=", value: 100 }],
						},
					},
					{
						text: "Lebih dari 85%",
						value: {
							label: ">85%",
							key: [{ column: "progres_data_wali", operator: ">", value: 85 }],
						},
					},
					{
						text: "65-85%",
						value: {
							label: "65-85%",
							key: [
								{ column: "progres_data_wali", operator: ">=", value: 65 },
								{ column: "progres_data_wali", operator: "<=", value: 85 },
							],
						},
					},
					{
						text: "35-65%",
						value: {
							label: "35-65%",
							key: [
								{ column: "progres_data_wali", operator: ">=", value: 35 },
								{ column: "progres_data_wali", operator: "<=", value: 65 },
							],
						},
					},
					{
						text: "Kurang dari 35%",
						value: {
							label: "<35%",
							key: [{ column: "progres_data_wali", operator: "<", value: 35 }],
						},
					},
					{
						text: "0%",
						value: {
							label: "0%",
							key: [{ column: "progres_data_wali", operator: "=", value: 0 }],
						},
					},
				],
				total: [
					{
						text: "100%",
						value: {
							label: "100%",
							key: [{ column: "progres_total", operator: "=", value: 100 }],
						},
					},
					{
						text: "Lebih dari 85%",
						value: {
							label: ">85%",
							key: [{ column: "progres_total", operator: ">", value: 85 }],
						},
					},
					{
						text: "65-85%",
						value: {
							label: "65-85%",
							key: [
								{ column: "progres_total", operator: ">=", value: 65 },
								{ column: "progres_total", operator: "<=", value: 85 },
							],
						},
					},
					{
						text: "35-65%",
						value: {
							label: "35-65%",
							key: [
								{ column: "progres_total", operator: ">=", value: 35 },
								{ column: "progres_total", operator: "<=", value: 65 },
							],
						},
					},
					{
						text: "Kurang dari 35%",
						value: {
							label: "<35%",
							key: [{ column: "progres_total", operator: "<", value: 35 }],
						},
					},
					{
						text: "0%",
						value: {
							label: "0%",
							key: [{ column: "progres_total", operator: "=", value: 0 }],
						},
					},
				],
				kunciData: [
					{
						text: "Terkunci",
						value: {
							label: true,
							key: [{ column: "kunci_data", operator: "=", value: 1 }],
						},
					},
					{
						text: "Terbuka",
						value: {
							label: false,
							key: [{ column: "kunci_data", operator: "=", value: 0 }],
						},
					},
				],
			},
			orders: [],
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
			indexMethod: (index) => {
				return (this.currentPage - 1) * this.pageSize + index + 1;
			},
			updatedProgresSiswa: async (data) => {
				const d = JSON.parse(data);
				const row = this.semuaSiswa.find((s) => s.siswa_id === d.siswa_id);
				if (row) {
					const progres = await this.getProgresDataSiswa(row.siswa_id);
					if (progres) {
						row.progres_detail_siswa_class = row.progres_detail_siswa !== progres.progres_detail_siswa ? "highlighted " : "";
						row.progres_data_ayah_class = row.progres_data_ayah !== progres.progres_data_ayah ? "highlighted " : "";
						row.progres_data_ibu_class = row.progres_data_ibu !== progres.progres_data_ibu ? "highlighted " : "";
						row.progres_data_wali_class = row.progres_data_wali !== progres.progres_data_wali ? "highlighted " : "";

						row.progres_detail_siswa = progres.progres_detail_siswa;
						row.progres_data_ayah = progres.progres_data_ayah;
						row.progres_data_ibu = progres.progres_data_ibu;
						row.progres_data_wali = progres.progres_data_wali;
						row.progres_total = progres.progres_total;
						row.last_update = progres.last_update;
						row.last_update_styled = new Date(progres.last_update).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "long" });

						row.progres_detail_siswa_class += this.getTextStyle(progres.progres_detail_siswa);
						row.progres_data_ayah_class += this.getTextStyle(progres.progres_data_ayah);
						row.progres_data_ibu_class += this.getTextStyle(progres.progres_data_ibu);
						row.progres_data_wali_class += this.getTextStyle(progres.progres_data_wali);
						row.progres_total_class = this.getTextStyle(progres.progres_total) + " highlighted";

						setTimeout(() => {
							row.progres_detail_siswa_class = this.getTextStyle(progres.progres_detail_siswa);
							row.progres_data_ayah_class = this.getTextStyle(progres.progres_data_ayah);
							row.progres_data_ibu_class = this.getTextStyle(progres.progres_data_ibu);
							row.progres_data_wali_class = this.getTextStyle(progres.progres_data_wali);
							row.progres_total_class = this.getTextStyle(progres.progres_total);
						}, 600);
					}
				}
			},
			changedKunciDataSiswa: (data) => {
				const d = JSON.parse(data);
				const siswaIds = d.siswa_ids || [];

				const table = this.$refs.tableProgresSemuaSiswa;
				for (const ss of this.semuaSiswa) {
					if (siswaIds.includes(ss.siswa_id)) {
						ss.kunci_data = d.kunci_data;
						table.toggleRowSelection(ss, false);
					}
				}
			},
		};
	},
	components: {},
	computed: {
		semesterAktif() {
			return this.$store.getters.getSemester;
		},
		isPengelola() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "superadmin", "admin-kesiswaan", "pengelola"].includes(r.role));
		},
	},
	watch: {
		semester: {
			immediate: true,
			async handler(val) {
				if (val) {
					this.loading = true;
					await new Promise((resolve) => {
						setTimeout(async () => {
							await this.getProgresSemuaSiswa();
							resolve();
						}, 500);
					});
					this.loading = false;
				}
			},
		},
		searchKey() {
			clearTimeout(this.debounceSearch);
			this.loading = true;

			this.debounceSearch = setTimeout(this.getProgresSemuaSiswa, 500);
		},
		filters() {
			this.getProgresSemuaSiswa();
		},
		orders() {
			this.getProgresSemuaSiswa();
		},
	},
	mounted() {
		this.getListSemester();
		this.semester = this.semesterAktif;
		this.$ws.main.on("detail-siswa:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-ayah:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-ibu:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-wali:updated", this.updatedProgresSiswa);
		this.$ws.main.on("kunci-data:changed", this.changedKunciDataSiswa);
	},
	beforeUnmount() {
		this.$ws.main.off("detail-siswa:updated");
		this.$ws.main.off("data-ayah:updated");
		this.$ws.main.off("data-ibu:updated");
		this.$ws.main.off("data-wali:updated");
		this.$ws.main.off("kunci-data:changed");
	},
	methods: {
		async getListSemester() {
			try {
				const { data } = await this.$defaultApi.post("/list/semester");

				this.listSemester = data.semester;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async getProgresSemuaSiswa() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/progres/siswa/all", {
					key: this.searchKey,
					semester_id: this.semester?.semester_id,
					filters: this.filters,
					sorts: this.orders,
					limit: this.pageSize,
					offset: (this.currentPage - 1) * this.pageSize,
				});

				const result = data.progres_siswa || [];
				result.forEach((r) => {
					r.progres_detail_siswa_class = this.getTextStyle(r.progres_detail_siswa);
					r.progres_data_ayah_class = this.getTextStyle(r.progres_data_ayah);
					r.progres_data_ibu_class = this.getTextStyle(r.progres_data_ibu);
					r.progres_data_wali_class = this.getTextStyle(r.progres_data_wali);
					r.progres_total_class = this.getTextStyle(r.progres_total);

					r.last_update_styled = new Date(r.last_update).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "long" });
					r.loading = false;
				});
				await new Promise((resolve) => {
					setTimeout(() => {
						this.semuaSiswa = result;
						this.totalData = data.count;

						resolve();
					}, 500);
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async getProgresDataSiswa(siswaId) {
			try {
				const { data } = await this.$defaultApi.post("/progres/siswa", {
					siswa_id: siswaId,
				});

				return data.progres_siswa;
			} catch (error) {
				console.error(error);
				return null;
			}
		},
		handleFilterChange(newFilter) {
			const [[key, value]] = Object.entries(newFilter);
			this.activeFilters.delete(key);
			this.filters = this.filters.filter((f) => f.column !== key);

			if (Array.isArray(value) && value.length) {
				const tmp = value[0];
				this.activeFilters.set(key, tmp.label);

				this.filters = this.filters.concat(tmp.key);
			}
		},
		handleSortChange({ prop, order }) {
			const newOrder = order === "descending" ? "DESC" : order === "ascending" ? "ASC" : null;
			this.orders = this.orders.filter((item) => item.column !== prop);

			if (newOrder) this.orders.push({ column: prop, order: newOrder });
		},
		handleHeaderClass({ column }) {
			const indexOrder = this.orders.findIndex((o) => o.column === column.property);
			if (indexOrder === -1) return "text-center bg-light";

			const sortDirection = this.orders[indexOrder].order;
			const classOrder = sortDirection === "ASC" ? "ascending" : "descending";
			return `text-center bg-light sort-order-${indexOrder} ${classOrder}`;
		},
		clearFilter() {
			if (this.filters.length) this.filters = [];

			this.activeFilters.clear();

			this.$refs.tableProgresSemuaSiswa.clearFilter();
		},
		clearSort() {
			if (this.orders.length) this.orders = [];

			this.$refs.tableProgresSemuaSiswa.clearSort();
		},
		changeSelection(val) {
			this.lockedSelected = val.filter((r) => r.kunci_data === 1).map((f) => f.siswa_id);
			this.unlockedSelected = val.filter((r) => r.kunci_data === 0).map((f) => f.siswa_id);
		},
		async gantiStatusKunciData(siswa, confirmed) {
			if (confirmed) {
				siswa.loading = true;
				try {
					await this.$defaultApi.post("/progres/kunci-data", {
						kunci_data: siswa.kunci_data === 0 ? 1 : 0,
						siswa_ids: [siswa.siswa_id],
					});
					this.$notify.success({
						title: "Berhasil",
						message: `Berhasil ${siswa.kunci_data ? "mengunci" : "membuka"} akses edit ${siswa.nama_siswa}`,
					});
				} catch (error) {
					if (error.response) {
						console.error(error.response.data.errMessage);
						return this.$notify.error({
							title: error.response.data.error || "Gagal",
							message: error.response.data.message,
						});
					}

					console.error(error);
				} finally {
					setTimeout(() => {
						siswa.loading = false;
					}, 500);
				}
			}
		},
		async kunciAksesEdit() {
			if (!this.unlockedSelected.length) {
				return this.$notify.warning({
					title: "Perhatian",
					message: "Tidak ada data terpilih dengan status akses edit terbuka",
				});
			}

			this.locking = true;
			try {
				const { data } = await this.$defaultApi.post("/progres/kunci-data", {
					kunci_data: 1,
					siswa_ids: this.unlockedSelected,
				});

				const table = this.$refs.tableProgresPerSiswa;
				this.unlockedSelected.forEach((id) => {
					const row = this.semuaSiswa.find((r) => r.siswa_id === id);
					if (row) table.toggleRowSelection(row, false);
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.locking = false;
				}, 500);
			}
		},
		async bukaAksesEdit() {
			if (!this.lockedSelected.length) {
				return this.$notify.warning({
					title: "Perhatian",
					message: "Tidak ada data terpilih dengan status akses edit tertutup",
				});
			}

			this.unlocking = true;
			try {
				const { data } = await this.$defaultApi.post("/progres/kunci-data", {
					kunci_data: 0,
					siswa_ids: this.lockedSelected,
				});

				const table = this.$refs.tableProgresPerSiswa;
				this.lockedSelected.forEach((id) => {
					const row = this.semuaSiswa.find((r) => r.siswa_id === id);
					if (row) table.toggleRowSelection(row, false);
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.unlocking = false;
				}, 500);
			}
		},
		getTextStyle(val) {
			if (val > 85) return "text-success";
			if (val > 65) return "text-success-emphasis";
			if (val > 35) return "text-warning";
			return "text-danger";
		},
	},
};
</script>

<style>
.sort-order-0,
.sort-order-1,
.sort-order-2,
.sort-order-3,
.sort-order-4,
.sort-order-5 {
	padding-right: 4px !important;
}
.sort-order-0::after,
.sort-order-1::after,
.sort-order-2::after,
.sort-order-3::after,
.sort-order-4::after,
.sort-order-5::after {
	font-size: 10px;
	position: absolute;
	top: 50%;
	right: 2px;
	transform: translateY(-50%);
	background-color: var(--el-color-primary);
	color: white;
	border-radius: 30%;
	width: 12px;
	height: 15px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.sort-order-0::after {
	content: "1";
}
.sort-order-1::after {
	content: "2";
}
.sort-order-2::after {
	content: "3";
}
.sort-order-3::after {
	content: "4";
}
.sort-order-4::after {
	content: "5";
}
.sort-order-5::after {
	content: "6";
}
</style>
